import { Auth0Provider as BaseAuth0Provider, type AppState } from '@auth0/auth0-react'
import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { auth0Config } from './config'

interface Props {
  children: ReactNode
}

export function Auth0Provider({ children }: Props) {
  const navigate = useNavigate()
  return (
    <BaseAuth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={auth0Config.authorizationParams}
      onRedirectCallback={(appState?: AppState) => {
        navigate(appState?.returnTo ?? '/my/wifi', { replace: true })
      }}
    >
      {children}
    </BaseAuth0Provider>
  )
}
